import PageHeading from "Layout/AppMain/PageHeading";
import moment from "moment";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Col, Row, Table, CardFooter, Button, UncontrolledButtonDropdown, DropdownMenu, DropdownToggle, Nav, NavLink, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Card, CardBody, ModalFooter } from "reactstrap";
import Loader from "react-loaders";
import { ReactComponent as Memo } from "../../../../../assets/utils/images/svgs/Memo.svg";
import { ReactComponent as EditPen } from "../../../../../assets/utils/images/svgs/editPen.svg";
import { ReactComponent as Delete } from "../../../../../assets/utils/images/svgs/Delete.svg";
import { ReactComponent as Save } from "../../../../../assets/utils/images/svgs/save_two.svg";
import { ReactComponent as Small_Arrow } from "../../../../../assets/utils/images/svgs/Small_Arrow.svg";
import AddressVerificationModal from "Components/Modal/AddressVerificationModal";
import TextLimit from "Api/TextLimit";
import { useNavigate, Link } from "react-router-dom";

const Calculate = ({ formDataState, setFormDataState, currentIndex, setCurrentIndex, getSubstitutorShifts, shiftListLoading, substitutorssData, setShiftListLoading, setSubstitutorssData, saveTravelcostData }) => {
    const [menuShow, setMenuShow] = useState(false);
    const [memoIsOpen, setMemoIsOpen] = useState(false);
    const [messageSalaris, setMessageSalaris] = useState("");
    const [messageVervanger, setMessageVervanger] = useState("");
    const [showUser, setShowUser] = useState({ message: '', type: null });
    const [editModal, setEditModal] = useState(false);
    const [addressData, setAddressData] = useState(null);
    const [selectedSchoolId, setSelectedSchoolId] = useState(null);
    const [modalMessage, setModalMessage] = useState("");
    const [modalMessageType, setModalMessageType] = useState("");
    const [validationError, setValidationError] = useState("");
    const [apiError, setApiError] = useState("");
    const [formattedAddress, setFormattedAddress] = useState("");
    const [validatedAddressData, setValidatedAddressData] = useState(null);
    const [validationMessage, setValidationMessage] = useState("");
    const [validationMessageType, setValidationMessageType] = useState("");
    const [addressConfirmed, setAddressConfirmed] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [showCalculateButton, setShowCalculateButton] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isCalculating, setIsCalculating] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        
        if (!formDataState?.substitutorShiftData?.list) return;

        const totalRepay = formDataState.substitutorShiftData.list.reduce((sum, item) => {
            const distanceChanged =
                item.originalDistance !== undefined &&
                Number(item.distance) !== Number(item.originalDistance);

            const value = distanceChanged ? Number(item.repay) * 2 : Number(item.repay || 0);

            return sum + (isNaN(value) ? 0 : value);
        }, 0);

        const kmInReturnReimbursed = formDataState.substitutorShiftData.list.reduce((sum, item) => {
            const kmChanged =
                item.originalKmInReturnReimbursed !== undefined &&
                Number(item.kmInReturnReimbursed) !== Number(item.originalKmInReturnReimbursed);

            const value = kmChanged ? Number(item.repay) * 2 : Number(item.kmInReturnReimbursed || 0);

            return sum + (isNaN(value) ? 0 : value);
        }, 0);

        setFormDataState(prev => ({
            ...prev,
            substitutorShiftData: {
                ...prev.substitutorShiftData,
                totalRepay,
                kmInReturnReimbursed
            }
        }));
    }, [formDataState.substitutorShiftData.list, formDataState.vKm]);

    const handleOpenModal = (data) => {
        setModalMessage("");
        setModalMessageType("");
        setValidationError("");
        setApiError("");
        setFormattedAddress(data.formattedAddress);
        setAddressData({
            vFirstName: data.vFirstName || '',
            vLastName: data.vLastName || '',
            tAddress: data.tAddress || '',
            vPostCode: data.vPostCode || '',
            vCity: data.vCity || '',
            vCountry: data.vCountry || '',
            iAdminId: data.iAdminId

        });

        if (data.bIsAddressVerified === 1) {
            setValidatedAddressData({
                verified: 1,
                tAddress: data.tAddress || '',
                vPostCode: data.vPostCode || '',
                vCity: data.vCity || '',
                vCountry: data.vCountry || ''
            });
        } else {
            setValidatedAddressData(null);
        }

        setEditModal(true);
        setValidationMessage('');
        setValidationError('');
        setAddressConfirmed(false);
    };

    const menuIsOpen = () => {
        setFormDataState({ ...formDataState, editable: null })
        if (menuShow === false) {
            setMenuShow(true);
        } else {
            setMenuShow(false);
        }
    }
    const totalRepay = useMemo(() => {
        if (!formDataState?.substitutorShiftData?.list) return 0;

        return formDataState.substitutorShiftData.list.reduce((sum, item) => {
            const distance = Number(item.distance || 0) - Number(formDataState.vKm || 0);
            const repay = distance < 0 ? 0 : distance;
            return sum + repay;
        }, 0);
    }, [formDataState.substitutorShiftData.list, formDataState.vKm]);

    useEffect(() => {
        if (!formDataState?.substitutorShiftData?.list) return;

        setSubstitutorssData(prevState => {
            if (!prevState) return prevState;
            const safeNumber = (v) => {
                const n = Number(v);
                return isNaN(n) ? 0 : parseFloat(n.toFixed(2));
            };
            const shiftsFromFormState = formDataState.substitutorShiftData.list.map(item => ({
                iSubsDateId: item.iSubsDateId,
                vCode: item.vCode || '',
                iSchoolId: item.iSchoolId,
                iDistance: safeNumber(item.distance),
                kmInReturnReimbursed: safeNumber(item.kmInReturnReimbursed),
                repay: safeNumber(item.repay),
                rowTotal: safeNumber(item.rowTotal),
                vPrice: safeNumber(formDataState.vPrice)
            }));

            const totalDistance = shiftsFromFormState.reduce(
                (sum, s) => sum + safeNumber(s.iDistance),
                0
            );

            const subtotal = shiftsFromFormState.reduce(
                (sum, s) => sum + safeNumber(s.rowTotal),
                0
            );

            const totalRepay = shiftsFromFormState.reduce(
                (sum, s) => sum + safeNumber(s.repay),
                0
            );


            const totalKmInReturnReimbursed = shiftsFromFormState.reduce(
                (sum, s) => sum + safeNumber(s.kmInReturnReimbursed),
                0
            );

            const updatedData = {
                ...prevState,
                iDistanceTotal: safeNumber(totalDistance),
                subtotal: safeNumber(subtotal),
                total: safeNumber(subtotal + Number(formDataState.vCorrect || 0)),
                vCorrect: safeNumber(formDataState.vCorrect),
                messageVervanger,
                messageSalaris,
                totalRepay,
                totalKmInReturnReimbursed,
                shifts: shiftsFromFormState
            };
            return updatedData;
        });

    }, [
        formDataState.substitutorShiftData.list,
        formDataState.vCorrect,
        formDataState.vKm,
        formDataState.vPrice
    ]);

    const skipSubstitutorId = () => {
        setSubstitutorssData({});
        const nextIndex = currentIndex + 1;
        if (nextIndex >= formDataState.selectedIds.length) {
            navigate("/reiskosten/overzicht")
        } else {
            setMessageSalaris('');
            setMessageVervanger('');
            setCurrentIndex(nextIndex);
            getSubstitutorShifts(nextIndex);
        }

    };

    const handleButtonClick = async () => {
        setShiftListLoading(true);
        const response = await saveTravelcostData();
        if (!response.status) {
            setShiftListLoading(false);
            return;
        }
        const nextIndex = currentIndex + 1;
        if (nextIndex >= formDataState.selectedIds.length) {
            navigate("/reiskosten/overzicht")
        } else {
            setMessageSalaris('');
            setMessageVervanger('');
            setCurrentIndex(nextIndex);
            getSubstitutorShifts(nextIndex);
        }

        setShiftListLoading(false);
    };

    const getValueBySubsDateId = useCallback((targetSubsDate) => {
        const list = formDataState?.substitutorShiftData?.list || [];
        const foundItem = list.find(item => (item?.vSubsDate === targetSubsDate.vSubsDate) && item?.iSubsDateId === targetSubsDate.iSubsDateId);
        return foundItem ? foundItem.distance : "";

    }, [formDataState?.substitutorShiftData?.list]);

    const updateValueBySubsDateId = (targetSubsDateId, newValue) => {
        setFormDataState(prevState => {
            const updatedList = prevState.substitutorShiftData.list.map(item => {
                if (item.iSubsDateId === targetSubsDateId) {
                    return {
                        ...item,
                        distance: Number(newValue),
                        isDistanceChanged: true
                    };
                }
                return item;
            });
            const { rowTotal, reimbursed } = countRowTotal(
                targetSubsDateId,
                updatedList,
                Number(newValue),
                prevState 
            );

            return updateRowTotal(
                prevState,
                targetSubsDateId,
                rowTotal,
                reimbursed,
                Number(newValue)
            );
        });
    };
    const countRowTotal = (targetSubsDateId, list, distance, state) => {
        const maxAmount = Number(String(state.vBedrag).replace(',', '.'));
        const pricePerKm = Number(String(state.vPrice).replace(',', '.'));


        const foundItem = list.find(i => i.iSubsDateId === targetSubsDateId);
        const reimbursed = foundItem?.isDistanceChanged
            ? getRepayKm({ ...foundItem, distance }) * 2
            : Number(foundItem?.kmInReturnReimbursed || 0);

        let rowTotal = reimbursed * pricePerKm;

        if (rowTotal < 0) rowTotal = 0;
        else if (rowTotal > maxAmount) rowTotal = maxAmount;

        return { rowTotal, reimbursed };
    };


    const updateRowTotal = (
        prevState,
        targetSubsDateId,
        rowTotal,
        reimbursed,
        distance
    ) => {
        const updatedList = prevState.substitutorShiftData.list.map(item => {
            if (item.iSubsDateId === targetSubsDateId) {
                return {
                    ...item,
                    distance,
                    repay: Math.max(distance - (formDataState.vKm || 0), 0),
                    kmInReturnReimbursed: reimbursed,
                    rowTotal
                };
            }
            return item;
        });

        const subtotal = updatedList.reduce(
            (sum, item) => sum + Number(item.rowTotal || 0),
            0
        );

        const total = subtotal + Number(prevState.vCorrect || 0);

        return {
            ...prevState,
            substitutorShiftData: {
                ...prevState.substitutorShiftData,
                list: updatedList,
                subTotal: subtotal,
                total
            }
        };
    };


    const updateVcorrectValue = (e) => {
        const value = e.target.value;

        setFormDataState(prev => ({
            ...prev,
            vCorrect: value
        }));

        setSubstitutorssData(prevState => {
            if (!Array.isArray(prevState)) return prevState;
            if (!formDataState.selectedIds || formDataState.selectedIds[currentIndex] === undefined) {
                return prevState;
            }

            return prevState.map(item => {
                if (item.iSubstitutorAdminId === formDataState.selectedIds[currentIndex]) {
                    return { ...item, vCorrect: Number(value) };
                }
                return item;
            });
        });
    };


    const handleMemoClick = (type) => {
        setMenuShow(false)
        if (type == "vervanger") {
            const updatedShowUser = { ...showUser, message: messageVervanger, type: type };
            setShowUser(updatedShowUser);
        }
        else {
            const updatedShowUser = { ...showUser, message: messageSalaris, type: type };
            setShowUser(updatedShowUser);
        }
    };


    const onChangeMessage = (value, type) => {
        const key = type === "vervanger" ? "messageVervanger" : "messageSalaris";


        setSubstitutorssData(prevState => ({
            ...prevState,
            [key]: value
        }));


        if (type === "vervanger") {
            setMessageVervanger(value);
        } else {
            setMessageSalaris(value);
        }

        setShowUser(prevShowUser => ({ ...prevShowUser, message: value }));
    }

    const handleSubmit = (type) => {
        setFormDataState(prevState => {
            const updatedState = { ...prevState, editable: null };
            if (type === "vervanger") {
                updatedState.messageVervanger = messageVervanger;
            } else {
                updatedState.messageSalaris = messageSalaris;
            }
            return updatedState;
        });
        setMemoIsOpen(false);
    }

    const onCancel = (type) => {
        if (type == "vervanger") {
            setMessageVervanger(formDataState.messageVervanger)
        } else {
            setMessageSalaris(formDataState.messageSalaris)
        }
        setMemoIsOpen(false)
    }

    const deleteTxt = (type) => {
        if (type === "vervanger") {
            setMessageVervanger('');
            setFormDataState({ ...formDataState, messageVervanger: '' });

            setSubstitutorssData(prevState => ({
                ...prevState,
                messageVervanger: '',
            }));
        } else {
            setMessageSalaris('');
            setFormDataState({ ...formDataState, messageSalaris: '' });

            setSubstitutorssData(prevState => ({
                ...prevState,
                messageSalaris: '',
            }));
        }
    };

    const getRepayKm = (shiftData) => {

        const distance = Number(shiftData?.distance || 0);
        const vKm = Number(formDataState.vKm || 0);
        return Math.max(distance - vKm, 0);
    };

    const duplicateDates = useMemo(() => {
        const counts = {};
        const schoolChanges = {};

        (formDataState.substitutorShiftData?.list || []).forEach(item => {
            const date = item.vSubsDate;
            const schoolName = item.
                iSchoolId
                ;

            if (date && schoolName) {
                const [day, month, year] = date.split('-');
                const normalizedDate = `${day}-${month}-${year}`;
                counts[normalizedDate] = (counts[normalizedDate] || 0) + 1;
                if (!schoolChanges[normalizedDate]) {
                    schoolChanges[normalizedDate] = new Set();
                }
                schoolChanges[normalizedDate].add(schoolName);
            }
        });

        return { counts, schoolChanges };
    }, [formDataState.substitutorShiftData?.list]);


    return (
        <div>
            <Row>
                <Col md="10" lg="10">
                    <PageHeading />
                </Col>
            </Row>
            {shiftListLoading ?
                <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                :
                (
                    <Row>
                        <Col md="12" lg="12">
                            <Card className="main-card mb-3 sub-detail-table-style">
                                <CardBody className="p-3">
                                    <Table size="sm" borderless className="mb-0 ">
                                        <tbody>
                                            <tr className="border-bottom-0 justify-content-between">
                                                <th className="fw-bold col-2 text-left">Vervanger</th>
                                                <th className="fw-bold col-2 text-center">Organisatie </th>
                                                <th className="fw-bold col-2 text-center">Periode</th>
                                                <th className="fw-bold col-2 text-right">Contracttype</th>
                                            </tr>
                                            <tr className="border-bottom-0 justify-content-between">
                                                <td className="wl text-left">
                                                    {window.innerWidth > 1250 ? TextLimit.AfwezigeLimitOptionOne(formDataState.substitutorShiftData.vFirstName, formDataState.substitutorShiftData.vMiddleName, formDataState.substitutorShiftData.vLastName)
                                                        : TextLimit.AfwezigeLimitOptionTwo(formDataState.substitutorShiftData.vFirstName, formDataState.substitutorShiftData.vMiddleName, formDataState.substitutorShiftData.vLastName)}
                                                </td>
                                                <td className="wl text-center">
                                                    {formDataState.substitutorShiftData.communityName}
                                                </td>
                                                <td className="wl text-center">
                                                    {formDataState.substitutorShiftData.startDate + " tot " + formDataState.substitutorShiftData.endDate}
                                                </td>
                                                <td className="wl text-right">
                                                    {formDataState.substitutorShiftData.contractTypes}
                                                </td>
                                            </tr>
                                        </tbody>



                                    </Table>
                                </CardBody>
                            </Card>
                            <Card className="main-card mb-3 sub-detail-table-style">
                                <CardBody className="p-3">
                                    <Table hover className="mb-0 coor-verzoeken-table">
                                        <thead>
                                            <tr className="col-lg-12" >
                                                <th className="text-lef w-32 table-right-border table-bottom-border col-lg-3" colSpan="2">&nbsp;</th>
                                                <th colSpan="3" className="table-right-border text-center table-bottom-border py-2 col-lg-4">Kilometers enkele reis</th>
                                                <th colSpan="3" className="text-center table-bottom-border py-2  col-lg-5">Vergoeding retour</th>
                                            </tr>
                                            <tr>
                                                <th className=" py-2">Datum</th>
                                                <th className="py-2  table-right-border text-center" >School</th>
                                                <th className="py-2">Afstand </th>
                                                <th className="travelCost-card-text-width py-2 text-center">Niet vergoed </th>
                                                <th className="table-right-border travelCost-card-text-width py-2 text-center">Te vergoeden </th>
                                                <th className="travelCost-card-text-width py-2">Km te vergoeden retour</th>
                                                <th className="travelCost-card-text-width py-2 text-center">Vergoeding/km</th>
                                                <th className="py-2 text-end">Totaal</th>
                                            </tr>

                                        </thead>
                                        <tbody >
                                            {formDataState.substitutorShiftData && formDataState.substitutorShiftData.list &&
                                                Object.keys(formDataState.substitutorShiftData.list).map((key) => {
                                                    const shiftData = formDataState.substitutorShiftData.list[key];
                                                    const date = shiftData.vSubsDate;
                                                    const schoolName = shiftData.vSchoolName;

                                                    const [day, month, year] = date.split('-');
                                                    const normalizedDate = `${day}-${month}-${year}`;
                                                    const isSchoolDifferent = duplicateDates.schoolChanges[normalizedDate] && duplicateDates.schoolChanges[normalizedDate].size > 1;
                                                    const isDuplicate = duplicateDates.counts[normalizedDate] > 1;
                                                    const textStyle = (isDuplicate && isSchoolDifferent) ? { color: 'red' } : {};
                                                    const inputStyle = (isDuplicate && isSchoolDifferent) ? { color: 'red', borderColor: 'red' } : {};
                                                    return (

                                                        <tr
                                                        >


                                                            <td style={textStyle} >
                                                                {new Date(moment(formDataState.substitutorShiftData.list[key].vSubsDate, 'DD-MM-YYYY')).toLocaleDateString("nl-NL", { weekday: 'short' })}
                                                                {" " + formDataState.substitutorShiftData.list[key].vSubsDate}
                                                            </td>

                                                            {

                                                                formDataState.substitutorShiftData ?
                                                                    <>
                                                                        <td className="py-1 table-right-border text-center" style={textStyle}>
                                                                            <Link
                                                                                to={`/verzoeken/overzicht/${formDataState.substitutorShiftData.list[key].iSubstitutionId}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="cursor-pointer"
                                                                                style={{ textDecoration: "none", color: "inherit" }}
                                                                            >
                                                                                {formDataState.substitutorShiftData.list[key].vSchoolName}
                                                                            </Link>
                                                                        </td>
                                                                        <td className="py-1" >
                                                                            <input
                                                                                style={inputStyle}
                                                                                value={getValueBySubsDateId(formDataState.substitutorShiftData.list[key])}
                                                                                className="w-50 travelCost-card-input-style"
                                                                                min="0"
                                                                                type="number"
                                                                                onChange={(e) => {
                                                                                    updateValueBySubsDateId(
                                                                                        formDataState.substitutorShiftData.list[key].iSubsDateId,
                                                                                        e.target.value
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        <td className="py-1 text-center" >
                                                                            <input
                                                                                style={inputStyle}
                                                                                value={formDataState.vKm || ''} readOnly
                                                                                className="w-50 travelCost-card-input-style cursor-default text-center"
                                                                            >
                                                                            </input>

                                                                        </td>
                                                                        <td className="py-1 table-right-border text-center" style={textStyle}>
                                                                            {getRepayKm(shiftData)}
                                                                        </td>


                                                                    </>
                                                                    :
                                                                    <td className="table-right-border py-1" colSpan={6}></td>
                                                            }

                                                            {
                                                                formDataState.substitutorShiftData ?
                                                                    <>

                                                                        <td className="py-1 ps-4">
                                                                            <input
                                                                                readOnly
                                                                                className="travelCost-card-input-style cursor-auto currency-input-with-symbol text-center"
                                                                                value={
                                                                                    shiftData.isDistanceChanged
                                                                                        ? getRepayKm(shiftData) * 2
                                                                                        : Number(shiftData.kmInReturnReimbursed || 0)
                                                                                }
                                                                            />
                                                                        </td>






                                                                        <td className="py-1 text-center" >
                                                                            <div className="currency-input-container">
                                                                                <input
                                                                                    style={inputStyle}
                                                                                    type="text"
                                                                                    readOnly
                                                                                    className="travelCost-card-input-style cursor-auto currency-input-with-symbol text-center"
                                                                                    value={`€ ${Number(
                                                                                        String(formDataState?.substitutorShiftData?.list?.[key]?.vPrice ?? 0)
                                                                                            .replace(',', '.')
                                                                                    )
                                                                                        .toFixed(2)
                                                                                        .replace('.', ',')
                                                                                        }`}
                                                                                />


                                                                            </div>
                                                                        </td>
                                                                        <td className="py-1 text-end">
                                                                            € {(() => {
                                                                                const item = formDataState?.substitutorShiftData?.list?.[key];

                                                                                if (!item) return '0,00';
                                                                                const rowTotal = Number(item.rowTotal ?? 0)

                                                                                return rowTotal.toFixed(2).replace('.', ',');
                                                                            })()}
                                                                        </td>


                                                                    </>
                                                                    : <td colSpan={6} className="py-1"> </td>
                                                            }

                                                        </tr>
                                                    )
                                                }
                                                )}
                                        </tbody>
                                    </Table>
                                    <tr className="col-lg-12 d-flex reiskosten-table ">
                                        <td className="col-lg-3"></td>
                                        <td className="col-lg-4 text-end fw-normal px-3 custom-border-right pe-5">{totalRepay.toFixed(2).replace('.', ',')}</td>

                                        <td className="col-lg-5 d-flex justify-content-between px-3 ">
                                            <span className="col-lg-6 text-start px-6">
                                                {Number(substitutorssData?.totalKmInReturnReimbursed ?? 0)
                                                    .toFixed(2)
                                                    .replace('.', ',')}
                                            </span>


                                            <span className="col-lg-6 text-end neg-mr-12 ">
                                                {(() => {
                                                    const value = substitutorssData?.subtotal
                                                        ? Number(substitutorssData.subtotal)
                                                        : formDataState?.substitutorShiftData?.subTotal;

                                                    if (isNaN(value) || value < 0) return '€ 0,00';

                                                    return `€ ${value.toFixed(2).replace('.', ',')}`;
                                                })()}
                                            </span>

                                        </td>
                                    </tr>

                                    <Row>
                                        <Col md="6" lg="6" >
                                            {
                                                formDataState.messageSalaris != '' &&
                                                <>
                                                    <Row className="justify-content-start my-3">
                                                        <Col className="travelCost-text-head d-block">Memo voor salarisadministratie:-</Col>
                                                    </Row>
                                                    <Row className="justify-content-center my-3">
                                                        <Col className="travelCost-row-text-data">
                                                            {
                                                                formDataState.editable == "administrator" ?
                                                                    (
                                                                        <div>
                                                                            <textarea className="travelCost-textArea"
                                                                                value={messageSalaris}
                                                                                onChange={(e) => {
                                                                                    onChangeMessage(e.target.value, 'administrator')
                                                                                }}
                                                                            />
                                                                            <Button className="d-flex btn-color-style justify-content-center my-3 w-25" size="sm" outline color="primary" type="submit" onClick={() => handleSubmit('administrator')} >
                                                                                Opslaan
                                                                            </Button>
                                                                        </div>
                                                                    )
                                                                    :
                                                                    (
                                                                        <>
                                                                            <div>{formDataState.messageSalaris.length < 45 ? formDataState.messageSalaris : formDataState.messageSalaris.substring(0, 45) + "..."}</div>
                                                                            <EditPen className="mx-1" onClick={() => setFormDataState({ ...formDataState, editable: "administrator" })} />
                                                                            <Delete onClick={() => deleteTxt('administrator')} />
                                                                        </>
                                                                    )
                                                            }
                                                        </Col>
                                                    </Row>
                                                </>
                                            }
                                            {formDataState.messageVervanger != '' &&
                                                <>
                                                    <Row className="justify-content-start my-3">
                                                        <Col className="travelCost-text-head d-block">Memo voor vervanger:-</Col>
                                                    </Row>
                                                    <Row className="justify-content-center my-3">
                                                        <Col className="travelCost-row-text-data">
                                                            {
                                                                formDataState.editable == "vervanger" ?
                                                                    (
                                                                        <div>
                                                                            <textarea className="travelCost-textArea"
                                                                                value={messageVervanger}
                                                                                onChange={(e) => {
                                                                                    onChangeMessage(e.target.value, 'vervanger')
                                                                                }}
                                                                            />
                                                                            <Button className="d-flex btn-color-style justify-content-center my-3 w-25" size="sm" outline color="primary" type="submit" onClick={() => { handleSubmit('vervanger') }} >
                                                                                Opslaan
                                                                            </Button>
                                                                        </div>
                                                                    )
                                                                    :
                                                                    (
                                                                        <>
                                                                            <div>{formDataState.messageVervanger.length < 45 ? formDataState.messageVervanger : formDataState.messageVervanger.substring(0, 45) + "..."}</div>
                                                                            <EditPen className="mx-1" onClick={() => setFormDataState({ ...formDataState, editable: "vervanger" })} />
                                                                            <Delete onClick={() => deleteTxt('vervanger')} />
                                                                        </>
                                                                    )
                                                            }
                                                        </Col>
                                                    </Row>
                                                </>
                                            }
                                        </Col>
                                        <Col md="6" lg="6" className="justify-content-end align-items-center">

                                            <Row className="justify-content-end my-3 custom-gutters">
                                                <Col md="2" lg="2" className="travelCost-text-head">Correctie</Col>
                                                <Col md="2" lg="2" className="travelCost-text-data">
                                                    <span>€</span>
                                                    <input className="travelCost-correct-input ms-2" value={formDataState.vCorrect} onChange={updateVcorrectValue} />
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-end my-3 custom-gutters">
                                                <Col md="2" lg="2" className="travelCost-text-head">Totaal</Col>
                                                <Col md="2" lg="2" className="travelCost-text-data">
                                                    € {(() => {
                                                        const subtotal = Number(formDataState?.substitutorShiftData?.subTotal || 0);

                                                        const vCorrect = formDataState?.vCorrect
                                                            ? Number(String(formDataState.vCorrect).replace(',', '.'))
                                                            : 0;

                                                        const total = Math.max(0, subtotal + vCorrect);

                                                        return total.toFixed(2).replace('.', ',');
                                                    })()}
                                                </Col>


                                            </Row>

                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                        </Col>
                    </Row>
                )
            }
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex justify-content-between">
                        <UncontrolledButtonDropdown isOpen={menuShow}>
                            <DropdownToggle color="link" className="p-0">
                                <Button className="d-flex align-items-center btn-color-style markeren-btn mb-2 me-2" size="sm" outline color="primary" onClick={() => menuIsOpen()}>
                                    <Memo />
                                </Button>
                            </DropdownToggle>
                            <DropdownMenu className={"rm-pointers dropdown-menu-lg travelCost-dropdown"}>
                                <Nav vertical>
                                    <NavLink className="travelCost-light-text" onClick={() => { setMemoIsOpen(true); handleMemoClick('administrator') }}>
                                        Memo voor salarisadministratie
                                    </NavLink>

                                    <NavLink className="border-top travelCost-light-text" onClick={() => { setMemoIsOpen(true); handleMemoClick('vervanger') }}>
                                        Memo voor vervanger
                                    </NavLink>
                                </Nav>
                            </DropdownMenu>
                        </UncontrolledButtonDropdown>
                        <div>
                            <Button
                                outline
                                className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn mx-2"
                                onClick={() => handleOpenModal(formDataState.substitutorShiftData)}
                                type="button"
                                color="primary"
                            >
                                Adres wijzigen
                            </Button>
                            <AddressVerificationModal
                                isOpen={editModal}
                                toggle={() => setEditModal(false)}
                                addressData={addressData}
                                validatedAddressData={validatedAddressData}
                                modalMessage={modalMessage}
                                setModalMessage={setModalMessage}
                                modalMessageType={modalMessageType}
                                setModalMessageType={setModalMessageType}
                                validationMessage={validationMessage}
                                setValidationMessage={setValidationMessage}
                                validationMessageType={validationMessageType}
                                setValidationMessageType={setValidationMessageType}
                                validationError={validationError}
                                setValidationError={setValidationError}
                                formattedAddress={formattedAddress}
                                setFormattedAddress={setFormattedAddress}
                                addressConfirmed={addressConfirmed}
                                setAddressConfirmed={setAddressConfirmed}
                                isValidating={isValidating}
                                setIsValidating={setIsValidating}
                                isValidated={isValidated}
                                setIsValidated={setIsValidated}
                                isSaving={isSaving}
                                setIsSaving={setIsSaving}
                                isCalculating={isCalculating}
                                setIsCalculating={setIsCalculating}
                                selectedSchoolId={selectedSchoolId}
                                setSelectedSchoolId={setSelectedSchoolId}
                                formDataState={formDataState}
                                getSubstitutorList={getSubstitutorShifts}
                                apiAftercalculation={async (index, adminId) => {
                                    await getSubstitutorShifts(index, adminId);
                                }}

                            />
                            <Button
                                outline
                                className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn"
                                onClick={() => { skipSubstitutorId() }}
                                type="button"
                                color="primary"
                            >
                                Overslaan
                            </Button>
                            <Button
                                outline
                                className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn mx-2"
                                onClick={handleButtonClick}
                                type="button"
                                color="primary"
                            >
                                Verwerken ({currentIndex + 1}/{formDataState.selectedIds.length})
                            </Button>

                        </div>
                        <Modal id={"tooltip"} isOpen={memoIsOpen} toggle={() => setMemoIsOpen(!memoIsOpen)} className="modal-dialog__over feedback-modal-style opmerking-modal-styling info-modal-width ">
                            <ModalHeader>
                                <div className="modal-header-styling">
                                    {showUser.type == 'vervanger' ? 'Memo voor vervanger' : 'Memo voor salarisadministratie'}
                                </div>
                                <div className="cross-icon-color">
                                    <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => onCancel(showUser.type)}> </i>
                                </div>
                            </ModalHeader>

                            <ModalBody className="bg-white rounded">
                                <div className="d-flex justify-content-center">
                                    <textarea onChange={(e) => {
                                        onChangeMessage(e.target.value, showUser.type)
                                    }}
                                        value={showUser.message}
                                        className="form-style opmerking-input-styling my-2 travelCost-light-text"
                                        rows="6"
                                    ></textarea>
                                </div>
                                <ModalFooter>
                                    <Button className="d-flex align-items-center btn-color-style  opslaan-btn" size="sm" outline color="primary" onClick={() => handleSubmit(showUser.type)}>
                                        <Save />
                                        Opslaan
                                    </Button>
                                    <Button className="d-flex align-items-center btn-color-style back-btn" size="sm" outline color="primary" onClick={() => onCancel(showUser.type)}>
                                        <Small_Arrow />
                                        Terug
                                    </Button>
                                </ModalFooter>
                            </ModalBody>
                        </Modal>
                    </div>
                </CardFooter>
            </div>
        </div>
    )
};

export default Calculate;





